import { Container } from '@components/layout/grid'
import ExclusiveOffer from '@components/playbook/exclusive-offer'
import type { PageWithContext } from '@lib/utils/context'
import { getPlaybookLayout } from '@page-templates/playbook-page'

export const PlaybookPage: PageWithContext = () => {
    return (
        <Container>
            <ExclusiveOffer />
        </Container>
    )
}

PlaybookPage.getLayout = getPlaybookLayout()

export default PlaybookPage
